import React, { useState } from "react";
import { useSelector } from "react-redux";

import { SearchSuggest } from "../../../../../../../../../../../../components/form-controls/search-suggest/search-suggest/search-suggest.component";

import { PositionCategory } from "../../../../types/flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.interface";

import * as store from "../../../../store/flyer-detail-page-form-position-categories/flyer-detail-page-form-position-categories.store";

import { PositionCategoriesSearchResults } from "../position-categories-search-results/position-categories-search-results.component";

import { PositionCategoriesSearchProps } from "./position-categories-search.props";

export const PositionCategorySearch = (props: PositionCategoriesSearchProps) => {
  const searchResults = useSelector(store.getCategories);
  const [reset, setReset] = useState(false);

  const handleSearch = (searchTerm: string) => {
    if (searchTerm.length) {
      store.searchCategories(searchTerm);
    }
    setReset(false);
  };

  const onSelect = (category: PositionCategory) => {
    props.onSelect(category);
    setReset(true);
  };

  return (
    <SearchSuggest
      id="product-category"
      label="Class"
      onReset={store.clearCategoriesResults}
      onSearch={handleSearch}
      reset={reset}
      disabled={props.disabled || false}
    >
      <PositionCategoriesSearchResults
        showIf={Boolean(searchResults) && !reset}
        results={searchResults?.results || []}
        onSelect={onSelect}
      />
    </SearchSuggest>
  );
};
